<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row v-if="showSearch===true">
      <b-col cols="6">
        <b-row>
          <b-col cols="12" class="my-1">
            <b-form-group
                label="Buscar"
                label-for="filter-input"
                label-cols-sm="12"
                label-align="left"
                label-size="sm"
                class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Escribe para buscar por nombre de paciente"
                ></b-form-input>

                <b-input-group-append>
                  <b-button @click="buscarInput">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <div v-if="clinicas.length > 0" class="d-flex justify-content-center p-3 mt-2 align-items-center" style="height: 4vh; padding-top: auto; padding-bottom: 1%; background-color: #EBF9FF; border-radius: 20px;">
              <div class="d-flex" @click="mostrarClinicas()" v-b-tooltip.hover title="Filtrar por clinica">
                <a class=" filtro filtroActivo" @click.prevent id="popover-clinicas" href="#" tabindex="0">{{ obtenerTextoClinicas() }}</a>
                <em :class="showPopoverClinicas ? 'rotate-chevron' : ''" class="arrow_down_svg chevron-gris ml-2" style="width: 13px;"></em>

              </div>
              <b-popover target="popover-clinicas" triggers="focus" placement="bottom" :show.sync="showPopoverClinicas">
                <div class="p-2">
                  <div class="d-flex mt-2">
                    <b-form-checkbox
                        v-model="todasClinicas"
                        name="todasClinicas"
                        @input="seleccionarTodasClinicas"
                    >
                    </b-form-checkbox>
                    <p style="font-size: .9em;">Seleccionar todas las clínicas ({{clinicas.length}})</p>
                  </div>
                  <hr style="margin-top: 0px;"/>
                  <div v-if="clinicas.length === 0">
                    <p>No se encontraron resultados</p>
                  </div>
                  <div v-else class="scrollable-container-comisiones">
                    <div class="d-flex" v-for="(clinica, index) in clinicas" v-bind:key="index">
                      <b-form-checkbox
                          v-model="clinica.selected"
                      >
                      </b-form-checkbox>
                      <p style="font-size: .9em;">{{clinica.nombreClinica}}</p>
                    </div>
                  </div>

                </div>
                <div class="text-center">
                  <b-button variant="outline-info" @click="filtrarByClinica" size="sm">Aplicar</b-button>
                </div>
              </b-popover>
            </div>

          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-col cols="12" class="my-1">
          <b-form-group
              v-model="sortDirection"
              label="Filtrar en columnas"
              description="Deja en limpio para buscar en todas las columnas"
              label-cols-sm="12"
              label-align="left"
              label-size="sm"
              class="mb-0 transparent"
              v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
                v-model="filterOn"
                :aria-describedby="ariaDescribedby"
                class="mt-1 row"
            >
              <b-form-checkbox
                  class="col-4"
                  v-for="field in fields.filter( f => f.sortable)"
                  :key="fields.indexOf(field)"
                  :value="field.key"
              >{{ field.label }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        class="mt-5"
        align="center"
    ></b-pagination>
    <p>Total: {{ getTotalRows }}</p>
    <b-table
        empty-text="No hay registros para mostrar"
        empty-filtered-text="No hay coincidencias en la busqueda"
        :items="items"
        :fields="getFields"
        :per-page="perPage"
        :filter-included-fields="filterOn"
        :filter-function="filterFunction"
        show-empty
        responsive
        sticky-header
        fixed
        sort-icon-left
        bordered
        small
        style="overflow-x: scroll;"
        @sort-changed="onSortChanged"
    >
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope"/>
      </template>
    </b-table>
    <b-pagination
        v-model="currentPage"
        :total-rows="getTotalRows"
        :per-page="perPage"
        size="sm"
        class="mt-5"
        align="center"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  name: "TablaEsteroides",
  props: {
    items: {type: Array, required: true},
    fields: {type: Array, required: true},
    clinicas: {type: Array, default: () => []},
    showSearch: {
      type: Boolean,
      default: true,
    },
    tipoMovimiento: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      showPopoverClinicas: false,
      debug: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      todasClinicas: false,
    }
  },
  watch: {
    currentPage() {
      this.$emit('paginaActualHijo', this.currentPage);
    },
    items() {
      if(this.items[0] !== null && this.items[0] !== undefined) {
        if (this.tipoMovimiento === 2) {
          this.totalRows = this.items[0].origen.totalPaginas
        } else {
          this.totalRows = this.items[0].totalPaginas
        }
      } else {
        this.totalRows = 0;
      }
    },

  },
  computed: {
    getItems() {
      return this.items;
    },
    getFields() {
      return this.fields.filter(f => this.filterOn.length > 0 ? this.filterOn.find(fi => fi === f.key) : f);
    },
    getTotalRows() {
      return this.totalRows;
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.totalRows = this.items.length
    this.filter = '';
  },
  methods: {
    filterFunction(a, b) {
      const result = this.fields.map(header => {
        if (header.formatter) {
          return header.formatter(a[header.key]).toString().toUpperCase().includes(b.toUpperCase());
        } else {
          if (a[header.key]) return a[header.key].toString().toUpperCase().includes(b.toUpperCase());
        }
      })
      return result.filter(r => r !== undefined).reduce((a, b) => a || b)
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    buscarInput() {
      this.$emit("buscarInput", this.filter);
    },
    onSortChanged(ctx) {
      this.$emit('ordenacionCambiada', {
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      });
    },
    mostrarClinicas(){
      this.showPopoverClinicas = !this.showPopoverClinicas;
      if (this.showPopoverTiempo) {
        this.showPopoverTiempo = !this.showPopoverTiempo;
      }
    },
    seleccionarTodasClinicas() {
      if (this.todasClinicas) {
        this.clinicas.forEach(clinica => (clinica.selected = true));
      } else {
        this.clinicas.forEach(clinica => (clinica.selected = false));
      }
    },
    cantidadSeleccionados() {
      return this.clinicas.filter(clinica => clinica.selected).length;
    },

    obtenerTextoClinicas() {
      return this.cantidadSeleccionados() === this.clinicas.length ? 'Clínicas (Todas)' : `Clínicas (${this.cantidadSeleccionados()})`;
    },

    filtrarByClinica(){
      let clinicasSeleccionadas = this.clinicas.filter(clinica => clinica.selected === true).map(clinica => clinica.idClinica);
      this.$emit('filtrarByClinica', {
        idsClinica: clinicasSeleccionadas
      });
    },

  },
}
</script>
<style>
.b-table-sticky-header {
  overflow-y: auto;
  max-height: 500px !important;
}

.table-bordered th, .table-bordered td {
  border: 1px solid #dee2e6;
  width: 150px;
}

.filtroActivo{
  color: #0069A9 !important;
  font-size: .9em;
  font-weight: 500;
}

.rotate-chevron {
  transform: rotate(180deg);
}

.chevron-gris{
  filter: invert(57%) sepia(1%) saturate(376%) hue-rotate(68deg) brightness(89%) contrast(87%);
}
</style>
